import React from "react";
import "./taxonomyTree.css";

const TaxonomyNode = ({
  node,
  level = 0,
  index,
  selectedId,
  onSelect,
  onDoubleClick,
  expandedIds,
  setExpandedIds,
}) => {
  const hasChildren = node.children && node.children.length > 0;
  const isSelected = selectedId === node.id;
  const isExpanded = expandedIds.includes(node.id);

  const handleClick = () => {
    if (hasChildren) {
      if (isExpanded) {
        setExpandedIds(expandedIds.filter((id) => id !== node.id)); // collapse
      } else {
        setExpandedIds([...expandedIds, node.id]); // expand
      }
    }
    onSelect(node.id);
  };

  const handleDoubleClick = () => {
    if (!hasChildren && onDoubleClick) {
      onDoubleClick(node.id);
    }
  };

  return (
    <>
      <div
        className={`taxonomy-row ${index % 2 === 0 ? "even" : "odd"} ${
          isSelected ? "selected" : ""
        }`}
        style={{ paddingLeft: `${level * 20}px`, cursor: "pointer" }}
        onClick={handleClick}
        onDoubleClick={handleDoubleClick}
      >
        {hasChildren ? (
          <span className="toggle-icon">{isExpanded ? "▼" : "▶"}</span>
        ) : (
          <span className="toggle-icon" />
        )}
        <span className="taxonomy-label">
          {node.name} ({node.id})
        </span>
      </div>

      {isExpanded &&
        node.children?.map((child, i) => (
          <TaxonomyNode
            key={`${node.id}-${i}`}
            node={child}
            level={level + 1}
            index={i}
            selectedId={selectedId}
            onSelect={onSelect}
            onDoubleClick={onDoubleClick}
            expandedIds={expandedIds}
            setExpandedIds={setExpandedIds}
          />
        ))}
    </>
  );
};

const TaxonomyTree = ({
  data,
  selectedId,
  onSelect,
  onDoubleClick,
  expandedIds,
  setExpandedIds,
}) => (
  <div className="taxonomy-wrapper">
    <div className="taxonomy-header">Name (ID)</div>
    <div className="taxonomy-scroll">
      {(data || []).map((node, index) => (
        <TaxonomyNode
          key={node.id}
          node={node}
          index={index}
          selectedId={selectedId}
          onSelect={onSelect}
          onDoubleClick={onDoubleClick}
          expandedIds={expandedIds}
          setExpandedIds={setExpandedIds}
        />
      ))}
    </div>
  </div>
);

export default TaxonomyTree;
